import React from 'react';
import { ContactSection } from '../components/ContactSection';

// Lands directly on the contact content. The ContactSection already carries its
// own heading, so there is no separate (repeated) page title.
export function Contact() {
  return <ContactSection data-id="element-482" data-mp="1qolbfv4ycgii" />;
}